import React, { useCallback } from 'react'
import isEqual from 'lodash.isequal'
import { ListItemGroupData } from '../../../../components'
import ChangeHistoryCard from '../ChangeHistoryCard/ChangeHistoryCard'
import { useLanguages, useGroupData } from '../../../../hooks'
import transl from '../../ChangeHistory.transl'

const keysUsed = ['title', 'languages', 'archivalReferenceNumber', 'volumes', 'creator']

export default function MetadataHistory({ selectedChanges, onFinish }) {
  const metadata = selectedChanges?.metadata
  const groupData = useGroupData()

  const { getLanguagesFromCodes } = useLanguages()

  const getFormattedLanguages = useCallback(
    (languages) => {
      if (languages == null) return null
      if (isEqual(languages, [])) return []
      const formatted = getLanguagesFromCodes(languages)
      return formatted
    },
    [getLanguagesFromCodes]
  )

  return metadata != null ? (
    <>
      {Object.keys(metadata).map((data) => {
        if (
          metadata?.[data] == null ||
          !keysUsed.includes(data) ||
          (Array.isArray(metadata[data]) && metadata[data].length === 0)
        )
          return null
        let dataToUse = metadata[data]
        const status = createStatusObject(dataToUse, groupData?.group?.metadata?.[data], data)
        if (data === 'languages') dataToUse = getFormattedLanguages(metadata?.[data])
        return (
          <ChangeHistoryCard
            restoreStatus={status}
            date={selectedChanges?.date?.fromTimestamp}
            onFinish={onFinish}
            key={data}
          >
            <ListItemGroupData
              overline={transl[data]()}
              items={status?.status === 'REMOVED' ? [`(${transl.none()})`, transl[`${data}Removed`]()] : dataToUse}
              hasMoreLess={false}
            />
          </ChangeHistoryCard>
        )
      })}
    </>
  ) : null
}

function getWasValueRemoved(value) {
  if (Array.isArray(value)) {
    if (isEqual(value, [])) return true
    return false
  }
  if (value === '') return true
  return false
}

export function createStatusObject(data, metadataValue, key) {
  if (data == null || metadataValue == null) return null
  const statusObj = { data: { metadata: {} } }
  if (compareArrays(data, metadataValue)) statusObj.status = 'CURRENT'
  else if (getWasValueRemoved(data)) statusObj.status = 'REMOVED'
  else statusObj.status = 'RESTORE'
  statusObj.data.metadata[key] = data
  return statusObj
}

function compareArrays(foo, bar) {
  // so arrays with the same data but in a different order will be equal
  return isEqual(Array.isArray(foo) ? changeArrToObj(foo) : foo, Array.isArray(bar) ? changeArrToObj(bar) : bar)
}

function changeArrToObj(arr) {
  return arr.reduce((prev, curr) => {
    return { ...prev, [curr]: curr }
  }, {})
}
